/* eslint-disable no-param-reassign */
import { capi } from '../client';

const getDefaultState = () => ({
  session: null,
});

export default {
  namespaced: true,
  state: { ...getDefaultState() },
  getters: {
    session: (state) => state.session,
  },
  mutations: {
    setSession(state, session) {
      state.session = session;
    },
  },
  actions: {
    async refreshAndInitializeSession({ commit, rootGetters }) {
      const apiId = 'refreshAndInitializeSession';
      if (rootGetters[`isApiIdCallInProgress(${apiId})`]) return;
      commit('incrementApiCallsInProgress', apiId, { root: true });

      try {
        const initialRequestData = { locale: window.AppData.locale, servicePathAndSearch: `${window.location.pathname}${window.location.search}` };
        const { data: initialSessionStatus } = await capi.post('session', initialRequestData);
        let resp = { ...initialSessionStatus };

        if (initialSessionStatus?.ssoClientLoginUrl) {
          const { data: ssoData } = await capi.get(initialSessionStatus.ssoClientLoginUrl, { withCredentials: true })
            .catch((e) => { if (typeof e === 'object') e.response = { data: resp }; throw e; });
          const { data: loginData } = await capi.post('session', ssoData);
          resp = { ...loginData };
        }

        commit('setSession', resp);
      } catch (e) {
        commit('setSession', e?.response?.data || { valid: false });
      } finally {
        commit('decrementApiCallsInProgress', apiId, { root: true });
      }
    },
  },
};
